import {filter, keyBy, orderBy} from 'lodash-es';
import {getPlayersJsonSuccess, getPlayersSuggestedJsonSuccess, getPlayersSelectedJsonSuccess} from 'modules/actions';
import {PoolTabsType, StatusType} from 'modules/enums';
import Api from 'modules/utils/Api';
import {call, put} from 'typed-redux-saga/macro';

export const fetchPlayersSaga = function* () {
	const result = yield* call(Api.Jsons.players);
	const players = result.data.players || [];

	if( players?.length ) {
		const activePlayers = filter(players, {status: StatusType.ACTIVE});

		const getIds = (items: typeof players) => items.map(it => it.id);

		const filterFunctions = {
			[ PoolTabsType.POPULAR ]: (items: typeof players) =>
				orderBy(
					items
						.filter((player) => player.isPopular),
					'numberSelections',
					'desc',
				).map(it => it.id),
			[ PoolTabsType.SUGGESTED ]: getIds,
			[ PoolTabsType.FAVORITE ]: getIds,
			[ PoolTabsType.CLUB ]: getIds,
			[ PoolTabsType.HOT_PICKS ]: getIds,
		};

		yield* put(
			getPlayersJsonSuccess({
				players: keyBy(players, 'id'),
				poolPlayers: {
					[ PoolTabsType.POPULAR ]: filterFunctions[ PoolTabsType.POPULAR ](activePlayers),
					[ PoolTabsType.SUGGESTED ]:
						filterFunctions[ PoolTabsType.SUGGESTED ](activePlayers),
					[ PoolTabsType.FAVORITE ]: filterFunctions[ PoolTabsType.FAVORITE ](activePlayers),
					[ PoolTabsType.CLUB ]: filterFunctions[ PoolTabsType.CLUB ](activePlayers),
					[ PoolTabsType.HOT_PICKS ]: filterFunctions[ PoolTabsType.CLUB ](activePlayers),
				},
			}),
		);
	}
};

export const fetchSuggestedPlayersSaga = function* () {
	const suggested = yield* call(Api.Jsons.suggested_players);

	yield* put(getPlayersSuggestedJsonSuccess(suggested.data));
};


export const fetchPlayersSelectedJsoSaga = function* () {
	const players = yield* call(Api.Jsons.most_selected_players);

	yield* put(getPlayersSelectedJsonSuccess(players.data));
};

export default fetchPlayersSaga;
